interface Props {
  children: JSX.Element | undefined;
  environment?: string;
  isLoading?: boolean;
  // [FULL URL PATH OF OMNIBAR-SILENT-REFRESH.HTML FILE]
  logoutUrl?: string;
  productCode?: string;
  silentRefreshUri?: string;
  unifiedLogin?: boolean; // [PRODUCT LOGOUT URL]
}

const Shell = ({
  children,
  environment,
  isLoading,
  logoutUrl,
  productCode,
  silentRefreshUri,
  unifiedLogin,
}: Props) => (
  <omnibar-shell
    // @ts-expect-error: environment "does not exist on type"
    environment={environment}
    is-unified-login={unifiedLogin}
    logout-url={logoutUrl}
    product-code={productCode}
    silent-refresh-uri={silentRefreshUri}
  >
    <>
      {children}
      {isLoading && <raul-page-loader />}
    </>
  </omnibar-shell>
);

export default Shell;
